export default {
  lockedPerks: [],
  blacklist: [],
  ownedOnly: false,
  ownedPerks: [],
  activeGameplayFilters: [],
  allowedTags: null,
  chaos: 25
}
